/* eslint-disable */
import insuranceService from '../insuranceService';
import insuranceServiceMock from '../__mocks__/insuranceService';
import creditService from '../creditService';
import creditServiceMock from '../__mocks__/creditService';
import regionalCreditServiceMock from '../__mocks__/regionalCreditService';
import equifaxCreditServiceMock from '../__mocks__/equifaxCreditService';
import equifaxEnhancedCreditServiceMock from '../__mocks__/equifaxEnhancedCreditService';
import spotlightService from '@/modules/spotlight/service/spotlightService';
import spotlightServiceMock from '../__mocks__/spotlightService';

export const provideService = ({ product, isDemo = false }) => {
  let serviceInstance;

  switch (product) {
    case 'insurance':
      serviceInstance = isDemo ? insuranceServiceMock : insuranceService;
      break;
    case 'credit':
      serviceInstance = isDemo ? creditServiceMock : creditService;
      break;
    case 'regional-credit':
      serviceInstance = isDemo ? regionalCreditServiceMock : creditService;
      break;
    case 'equifax-credit':
      serviceInstance = isDemo ? equifaxCreditServiceMock : creditService;
      break;
    case 'equifax-enhanced-credit':
      serviceInstance = isDemo ? equifaxEnhancedCreditServiceMock : creditService;
      break;
    case 'spotlight':
      serviceInstance = isDemo ? spotlightServiceMock : spotlightService;
      break;
  }
  return serviceInstance;
};
